import { CaretDownIcon } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { css, html } from 'react-strict-dom';
import { Api } from 'src/api';
import {
  Avatar,
  DropdownMenu,
  DropdownMenuItem,
  Stack,
  Text,
} from 'src/components';
import { Color, Style } from 'src/constants';
import { color } from 'src/constants/color.css';
import { Model } from 'src/models';

type Props = {
  users: ReadonlyArray<Api.User.BaseView>;
  selectedUser: Api.User.BaseView;
};

export default function TasksUserSelect({ users, selectedUser }: Props) {
  const navigate = useNavigate();

  return (
    <DropdownMenu
      header="Show daily tasks for..."
      anchorSide="right"
      trigger={(open) => (
        <html.button
          style={[
            Style.row,
            Style.alignCenter,
            styles.trigger,
            open && styles.triggerOpen,
          ]}
        >
          <Stack style={[Style.row, Style.alignCenter]} gap={0.5}>
            <Avatar user={selectedUser} size={24} />
            <Text typeface="body.regular" color="neutral100">
              {Model.User.getFullName(selectedUser)}
            </Text>
            <CaretDownIcon size={16} color={Color.neutral60} />
          </Stack>
        </html.button>
      )}
    >
      {users.map((user) => (
        <DropdownMenuItem
          key={user.id}
          selected={user.id === selectedUser.id}
          showRadio={false}
          onClick={() => navigate(Model.User.getDailyTasksPath(user.id))}
        >
          {Model.User.getFullName(user)}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
}

const styles = css.create({
  trigger: {
    width: 'fit-content',
    paddingInline: 12,
    paddingBlock: 6,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: color.neutral20,
    borderRadius: 8,
    backgroundColor: color.neutral0,
    cursor: 'pointer',
    transition: 'border-color 0.15s',
    ':hover': {
      borderColor: color.neutral40,
    },
  },
  triggerOpen: {
    borderColor: color.neutral40,
  },
});
